import { render, staticRenderFns } from "./modalDetailError.vue?vue&type=template&id=570a1d24&scoped=true"
import script from "./modalDetailError.vue?vue&type=script&lang=js"
export * from "./modalDetailError.vue?vue&type=script&lang=js"
import style0 from "./modalDetailError.vue?vue&type=style&index=0&id=570a1d24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570a1d24",
  null
  
)

export default component.exports